<template>
  <section class="info-charge-use-pattern">
    <div class="card shadow">
      <div class="card-body pb-0">

        <div class="row justify-content-between mb-3">
          <card-title class="col" icon-image="mdi-car" title="운전자 충전 패턴" text-color="title"/>
          <div class="col text-end">
            <b-button variant="outline-success" :disabled="isHistoryEmpty" @click="openModal">
              <i class="mdi mdi-text"/> <span class="ms-3">충전 이력 보기</span>
            </b-button>
          </div>
        </div>

        <div class="row justify-content-center mb-3">
          <div class="col-lg-4 ct-mb-margin-bottom-100">
            <info-mini-box box-bg="light"
                           title-bg="dark-gradient" :title-width="40" title="충전량"
                           value-color="black" :value-width="60"
                           :value="`${monthlySumData ? monthlySumData.totEnergy : 0} kWh`"/>
          </div>
          <div class="col-lg-4 ct-mb-margin-bottom-100">
            <info-mini-box box-bg="light"
                           title-bg="dark-gradient" :title-width="40" title="충전 금액"
                           value-color="black" :value-width="60"
                           :value="`${monthlySumData ? monthlySumData.totCost.toLocaleString() : 0} 원`"/>
          </div>
          <div class="col-lg-4 ct-mb-margin-bottom-100">
            <info-mini-box box-bg="light"
                           title-bg="dark-gradient" :title-width="40" title="충전 시간"
                           value-color="black" :value-width="60"
                           :value="`${monthlySumData ? monthlySumData.usedTime : '0 시간'}`"/>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body pb-0">
                <div class="row">

                  <div class="col-xl-4">
                    <div class="card border-0">
                      <div class="row justify-content-between">
                        <card-title class="col fs-6" title="요일별 충전 현황" text-color="title"/>
                        <div class="col text-end">
                          <div class="form-switch">
                            <input type="checkbox" class="form-check-input" id="monthCheckedForm"
                                   v-model="isMonthlyView" :disabled="isDisableSwitch"
                                   :aria-expanded="isMonthlyView ? 'true' : 'false'"/>
                            <label class="form-check-label ms-2" for="monthCheckedForm">전체 요일 조회</label>
                          </div>
                        </div>
                      </div>
                      <div class="border border-1">
                        <apexchart ref="weekDaysChart" height="260" :options="weekDaysChartOptions"
                                   :series="weekDaysChartOptions.series"/>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-4">
                    <div class="card border-0">
                      <card-title class="fs-6" title="시간별 충전 현황" text-color="title"/>
                      <div class="border border-1">
                        <apexchart ref="useageTimeChart" height="260" :options="useageTimeChartOptions"
                                   :series="useageTimeChartOptions.series"/>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-4">
                    <div class="card border-0">
                      <card-title class="fs-6" title="충전기 이용 현황" text-color="title"/>
                      <div class="border border-1">
                        <apexchart ref="usedChargerChart" height="260" :options="usedChargerChartOptions"
                                   :series="usedChargerChartOptions.series"/>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <user-charging-history-modal ref="userChargingHistoryModal"
                                 :searchArgs="searchArgs"/>

  </section>
</template>

<script>
import CardTitle from "@/views/components/cardTitle.vue";
import UserChargingHistoryModal from "@/views/pages/driver/userChargingHistoryModal.vue";
import { http } from "@/mdk/auth-api";
import infoMiniBox from "@/views/components/infoMiniBox.vue";

export default {
  name: 'infoChargeUsePattern',
  components: { CardTitle, UserChargingHistoryModal, infoMiniBox },
  props: {
    searchArgs: Object
  },
  data() {
    return {
      weekdays: ['월', '화', '수', '목', '금', '토', '일'],
      isHistoryEmpty: true,
      isDisableSwitch: true,
      isMonthlyView: true,
      selectedDayIdx: null,
      selectedColors: [ '#a9de4e', '#00678f' ],
      monthlySumData: null,
      weekDaysChartData: null,
      useageTimeData: null,
      usedChargerData: null,
      weekDaysChartOptions: {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'NanumSquareRound',
          distributed: false,
          events: {
            dataPointSelection: (e, chart, opts) => this.selectDay(e, chart, opts)
          },
        },
        colors: [ '#50c080', '#0064ff' ],
        fill: {
          opacity: 1,
          colors: [ '#50c080', '#0064ff' ],
        },
        stroke: {
          curve: 'smooth',
          width: ['', 1],
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 3
          }
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: ['월', '화', '수', '목', '금', '토', '일'],
          tickPlacement: 'between',
          labels: {
            hideOverlappingLabels: false,
          },
          axisTicks: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: [{
          seriesName: '이용',
          opposite: false,
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => `${val.toFixed(0)}`,
          },
          title: {
            text: "이용",
            style: {
              fontWeight: 600,
            }
          }
        },
          {
            seriesName: '충전량',
            opposite: true,
            labels: {
              formatter: val => `${(Math.round(val * 10) / 10).toLocaleString('ko-KR')}`,
            },
            title: {
              text: "충전량",
              style: {
                fontWeight: 600,
              }
            },
          }
        ],
        legend: {
          markers: {
            width: 12,
            height: [12, 2],
            radius: 2,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            formatter: x => `${x}요일`,
          },
          y: [{
            formatter: y => `${y.toFixed(0)} 건`,
          },{
            formatter: y => `${Math.round(y * 100) / 100} kWh`,
          }]
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            borderRadius: 2,
            borderRadiusApplication: 'end',
          }
        },
        series: [],
        noData: {
          text: 'No Data',
          offsetY: -15,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          }
        }
      },
      useageTimeChartOptions: {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'NanumSquareRound',
        },
        colors: [ '#50c080', '#0064ff' ],
        fill: {
          opacity: 1,
          colors: [ '#50c080', '#0064ff' ],
        },
        stroke: {
          curve: 'smooth',
          width: ['', 1],
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 3
          }
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: Array.from({ length: 24 }, (v, i) => i),
          tickPlacement: 'between',
          labels: {
            hideOverlappingLabels: false,
            style: {
              fontSize: '11px',
            },
          },
          axisTicks: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: [{
          seriesName: '이용',
          opposite: false,
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => `${val.toFixed(0)}`,
          },
          title: {
            text: "이용",
            style: {
              fontWeight: 600,
            }
          }
        },
          {
            seriesName: '충전량',
            opposite: true,
            labels: {
              formatter: val => `${(Math.round(val * 10) / 10).toLocaleString('ko-KR')}`,
            },
            title: {
              text: "충전량",
              style: {
                fontWeight: 600,
              }
            },
          }
        ],
        legend: {
          markers: {
            width: 12,
            height: [12, 2],
            radius: 2,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            formatter: x => `${x}시 ~ ${x + 1}시`,
          },
          y: [{
            formatter: y => `${y.toFixed(0)} 건`,
          }, {
            formatter: y => `${Math.round(y * 100) / 100} kWh`,
          }]
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            borderRadius: 1,
            borderRadiusApplication: 'end',
          }
        },
        series: [],
        noData: {
          text: 'No Data',
          offsetY: -15,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
          hover: {
            filter: {
              type: 'none',
            }
          },
        },
      },
      usedChargerChartOptions: {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'NanumSquareRound',
        },
        colors: [ '#50c080', '#0064ff' ],
        fill: {
          opacity: 1,
          colors: [ '#50c080', '#0064ff' ],
        },
        stroke: {
          curve: 'smooth',
          width: ['', 1],
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 3
          }
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: [],
          tickPlacement: 'between',
          labels: {
            hideOverlappingLabels: false,
          },
          axisTicks: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: [{
          seriesName: '이용',
          opposite: false,
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => `${val.toFixed(0)}`,
          },
          title: {
            text: "이용",
            style: {
              fontWeight: 600,
            }
          }
        },
          {
            seriesName: '성공률',
            opposite: true,
            min: 0,
            max: 100,
            tickAmount: 4,
            title: {
              text: "성공률",
              style: {
                fontWeight: 600,
              }
            },
          }
        ],
        legend: {
          markers: {
            width: 12,
            height: [12, 2],
            radius: 2,
          },
        },
        tooltip: {
          enabled: true,
          y: [{
            formatter: y => `${y.toFixed(0)} 건`,
          },{
            formatter: y => `${y} %`,
          }]
        },
        plotOptions: {
          bar: {
            columnWidth: '15px',
            borderRadius: 2,
            borderRadiusApplication: 'end',
          }
        },
        series: [],
        noData: {
          text: 'No Data',
          offsetY: -15,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
          hover: {
            filter: {
              type: 'none',
            }
          },
        },
      },
    }
  },
  watch: {
    searchArgs: {
      deep: true,
      handler() {
        const vm = this;

        vm.clear();
        vm.getDriverPattern();
        vm.getMonthlySumData();
      },
    },
    isMonthlyView: {
      handler(val) {
        const vm = this;

        if (val === true) {
          vm.$refs.weekDaysChart.toggleDataPointSelection(0, vm.selectedDayIdx);
          vm.selectedDayIdx = null;
        } else if (vm.selectedDayIdx === null) {
          vm.$refs.weekDaysChart.toggleDataPointSelection(0, 0);
        }
      }

    }
  },
  methods: {
    openModal() {
      const vm = this;
      vm.$refs.userChargingHistoryModal.show = true;
    },
    async getDriverPattern() {
      const vm = this;
      const _url = `/onmapi/charging-service/pattern`;

      try {
        const res = await http.get(_url, {
          params: {
            targetMonth: vm.searchArgs.month,
            userId: vm.searchArgs.userId,
            placeId: vm.searchArgs.stationId }
        });

        vm.weekDaysChartData = res.data.items.weeklyUsageStats;
        vm.useageTimeData = res.data.items.weeklyUsageTimes;
        vm.usedChargerData = res.data.items.usedChargerStats;

        vm.updateWeekDaysChart();
        vm.updateTwoChartPerDay();

      } catch (err) {
        console.error(err)
      }
    },
    async getMonthlySumData() {
      const vm = this;
      const _url = `/onmapi/charging-service/monthly-sum`;

      try {
        const res = await http.get(_url, {
          params: {
            targetMonth: vm.searchArgs.month,
            userId: vm.searchArgs.userId,
            placeId: vm.searchArgs.stationId }
        });

        vm.monthlySumData = { ...res.data.items };

      } catch (err) {
        console.error(err)
      }
    },
    updateWeekDaysChart() {
      const vm = this;

      const sumCountData = [...vm.weekDaysChartData].map(ele => ele.sumCount);
      const sumEnergyData = [...vm.weekDaysChartData].map(ele => ele.sumEnergy);

      vm.$refs.weekDaysChart.updateSeries([{
        name: '이용',
        type: 'bar',
        data: sumCountData
      }, {
        name: '충전량',
        type: 'line',
        data: sumEnergyData
      }]);

      vm.isDisableSwitch = false;
    },
    updateTwoChartPerDay(day) {
      const vm = this;

      const useageTimeData = vm.isMonthlyView ? vm.useageTimeData['전체'] : vm.useageTimeData[day];
      const usedChargerData = vm.isMonthlyView ? vm.usedChargerData['전체'] : vm.usedChargerData[day];
      const changedColors = vm.isMonthlyView ? [ '#50c080', '#0064ff' ] : vm.selectedColors;

      const hourUsageCount = [ ...useageTimeData.hourUsageCount ];
      const hourEnergy = [ ...useageTimeData.hourEnergy ];
      const chargerList = [ ...usedChargerData.csoEvseNum[0] ];
      const chargedCount = [ ...usedChargerData.count[0] ];
      const successRate = [ ...usedChargerData.successRate[0] ];

      vm.$refs.useageTimeChart.updateOptions({
        colors: changedColors,
        fill: {
          opacity: 1,
          colors: changedColors,
        },
        series: [{
          name: '이용',
          type: 'bar',
          data: hourUsageCount
        }, {
          name: '충전량',
          type: 'line',
          data: hourEnergy
        }]
      });

      vm.$refs.usedChargerChart.updateOptions({
        xaxis: { categories: chargerList },
        colors: changedColors,
        fill: {
          opacity: 1,
          colors: changedColors,
        },
        series: [{
          name: '이용',
          type: 'bar',
          data: chargedCount
        }, {
          name: '성공률',
          type: 'line',
          data: successRate
        }]
      });
    },
    selectDay(e, chart, opts) {
      const vm = this;

      vm.emphasizeXAxisLabel(opts.dataPointIndex);
      vm.updateTwoChartPerDay(vm.weekdays[opts.dataPointIndex]);
    },
    emphasizeXAxisLabel(idx) {
      const vm = this;
      const weekDaysChartXAxisTexts = vm.$refs.weekDaysChart.$el.querySelectorAll('.apexcharts-xaxis text');
      const weekDaysChartBarArea = vm.$refs.weekDaysChart.$el.querySelectorAll('.apexcharts-bar-area');
      const selectedStyle = 'font-weight: 800; font-size: 15px; fill: black;';

      if (vm.selectedDayIdx === idx) {
        weekDaysChartXAxisTexts[idx].style.cssText = '';
        weekDaysChartBarArea[idx].style.fill = '';
        vm.selectedDayIdx = null;
        vm.isMonthlyView = true;

      } else {
        if (vm.selectedDayIdx !== null) {
          weekDaysChartXAxisTexts[vm.selectedDayIdx].style.cssText = '';
          weekDaysChartBarArea[vm.selectedDayIdx].style.fill = '';
        }
        weekDaysChartXAxisTexts[idx].style.cssText = selectedStyle;
        weekDaysChartBarArea[idx].style.fill = vm.selectedColors[0];
        vm.selectedDayIdx = idx;
        vm.isMonthlyView = false;
      }
    },
    clear() {
      const vm = this;

      vm.isMonthlyView = true;
      vm.isHistoryEmpty = false;

      vm.$refs.weekDaysChart.updateOptions(vm.weekDaysChartOptions);
      vm.$refs.useageTimeChart.updateOptions(vm.useageTimeChartOptions);
      vm.$refs.usedChargerChart.updateOptions(vm.usedChargerChartOptions);
    }
  }
}
</script>
